/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PostfixMapType = {
    Btree: 'BTREE',
    Cidr: 'CIDR',
    Hash: 'HASH',
    Pcre: 'PCRE',
    Regexp: 'REGEXP'
} as const;

export type PostfixMapType = typeof PostfixMapType[keyof typeof PostfixMapType];



